import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import axios from 'axios';
import Spinner from '../../common/Spinner';
import { getDecodedData } from "../../../helpers";
import { baseUrl } from '../../../config/baseUrl';

const BACKEND_URL = `${baseUrl.earth}/sale/hosted`;

function SaleHostedForm() {
  const [gatewayData, setGatewayData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { query } = queryString.parseUrl(window.location.href);
    const { data, response } = query;

    if (!data) {
      setError('Missing payment data in URL');
      return;
    }

    const getHostedForm = async () => {
      try {
        const res = await axios.get(BACKEND_URL, { params: { data, response } });
        setGatewayData(res.data);
      } catch (err) {
        let message;
        if (err.response?.data?.errorResponse?.error) {
          message = err.response.data.errorResponse.error.message;
        }

        if (message === 'Payment already done' && err.response?.status === 500) {
          const { decodedString } = await getDecodedData(response);
          window.location.replace(decodedString.redirect_url);
        } else {
          console.error('Failed to initiate payment:', err?.message);
          setError('Failed to initiate payment. Please try again.');
        }
      }
    };

    getHostedForm();
  }, []);

  // Auto-submit the form once gateway data is available
  useEffect(() => {
    if (gatewayData) {
      const data = {
        id: 'my-payment-form',
        url: gatewayData.gatewayUrl,
        modal: true,
        data: gatewayData.fields,
        submit: {
          type: 'auto',
          label: 'Pay Now',
          attrs: { class: 'btn btn-primary' },
        }
      };

      const form = new window.hostedForms.classes.Form('paynow', data);
      const t = setTimeout(() => setLoading(false), 2000);

      return () => {
        clearTimeout(t);
        form?.destroy();
      };
    }
  }, [gatewayData]);

  useEffect(() => {
    if (!error) return;

    const { query } = queryString.parseUrl(window.location.href);
    const { data, response } = query;

    const failureUrl = `${window.location.origin}/failure?${queryString.stringify({
      data,
      response,
      message: error
    })}`;

    window.location.replace(failureUrl);
  }, [error]);

  return (
    <>
      {loading && <Spinner message="Please wait, loading payment page" />}
      <div id="paynow"></div>
    </>
  );
}

export default SaleHostedForm;
